const TARGET_NODE = process.env.VUE_ENV === "server";

function getTdk(vm) {
  const { tdk } = vm.$options;
  if (tdk) {
    return tdk.call(vm);
  }
}

function updateTdk(vm, vdom) {
  const tdk = getTdk(vm);
  const staticKeyWords = ""//" 类型：影视动漫,剪辑合成,分镜设计,广告企业宣传,游戏,美术设计,脚本,模型制作,动画制作,特效制作,音效配音,短视频,动新闻,其它,场景,插画,人物,概念,素描,生物,道具,动作捕捉,K帧";
  vdom.title = (tdk && tdk.title) || "SSR PAGE";
  vdom.description = (tdk && tdk.description) || "";
  vdom.keywords = (tdk && tdk.keywords) + staticKeyWords || "";
  // for append more meta or link seo need
  vdom.ssrHeadAddInfo = (tdk && tdk.ssrHeadAddInfo) || "";
  vdom.hideDiv = (tdk && tdk.hideDiv) || "";
}

function serverUpdateTdk() {
  updateTdk(this, this.$ssrContext);
}

function clientUpdateTdk() {
  updateTdk(this, document);
}

export default (TARGET_NODE ? serverUpdateTdk : clientUpdateTdk);
